<!--  -->
<template>
<div>
    <van-popup
      v-model="show"
      position="bottom"
      :style="{ height: '82%' }"
      duration="0.18"
      :close-on-click-overlay="false"
       closeable
      close-icon="cross"
       @close="onClose"
    >
      <div class="courseTitle">
        <h2>{{currentCourse.cartPackageItem.name }}</h2>
        <h3><span>¥</span>{{sellPrice}}</h3>
      </div>
      <div class="content">
        <div class="content-box">
          <div class="mandatory">
            <div class="mandatory-box" v-for="(item, index) in mandatoryCourse"  :key="index">
              <SelectCourseCard :courseInfo="item" @skuInfo="skuInfo" :currentCourse="currentCourse"/>
            </div>
          </div>
          <div class="optional" v-for="(child, index) in optionCourse" :key="index">
            <div class="group-name">
              <p>{{ child.groupInfo.name }}</p>
              <span>以下课程选择{{ showNum(child.groupInfo.selectProductNum) }}门</span>
            </div>
            <ul class="optional-course">
              <li
                :class="{
                  active: item.isSelect,
                  disbaled: (child.disbaled && !item.isSelect) || item.disaled,
                }"
                v-for="(item, idx) in child.productSkuList"
                :key="idx"
                @click="chooseCourse(item, index, idx)"
              >
                <p class="ellipsis">
                  {{ item.name }}
                </p>
                <img :src="checkIcon" alt="" />
                <span>{{ String(item.skuName) }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="foot">
         <div class="foot-box" @click="deterMineBtn">
           确定<span v-if="price !== null " class="price"><b style="font-size: 80%;">¥</b>{{price}}</span>
        </div>
      </div>
    </van-popup>
    </div>
</template>
<script>
import { getBigNum } from '@/utils/tools';
import checkIcon from '@/assets/img/components/courseDetail/checkIcon.png';
import { reqCombinationDetail } from '@/api/combination';
import { reqChangeGood } from '@/api/courseDetail/shoppingCar/shoppingCar';
import SelectCourseCard from './selectCourseCard.vue';
import { reqPrice } from '@/api/pay';

export default {
  components: {
    SelectCourseCard,
  },
  data() {
    return {
      checkIcon,
      mandatoryCourse: [], // 必须课程
      optionCourse: [], // 可选课程
      chooseNum: 2, // 可选择的数量
      selectCourse: [], // 选择的课程
      numList: [],
      show: true,
      sellPrice: 0, // 套餐价格
      price: null,
      priceType: 1,
    };
  },
  props: {
    currentCourse: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
  },
  mounted() {
  },
  created() {
    this.$toast.loading({
      message: '加载中...',
      forbidClick: true,
      duration: 0,
    });
    this.getDeatil();
  },
  methods: {
    // 请求套餐详情信息包含当前可选规格
    async getDeatil() {
      const { packageId } = this.currentCourse.cartPackageItem;
      const { code, data } = await reqCombinationDetail(packageId);
      if (code === 0) {
        this.sellPrice = data.sellPrice;
        this.priceType = data.priceType;
        this.combinationDeatil = data;
        this.initData();
      }
    },
    onClose() {
      this.$emit('singleClose');
    },
    showNum(num) {
      return getBigNum(num, 2);
    },
    chooseCourse(course, index, idx) {
      this.optionCourse[index].productSkuList[idx].isSelect = !course.isSelect;
      let num = 0;
      this.optionCourse.forEach((item) => {
        item.productSkuList.forEach((child) => {
          // 同产品不同sku 互斥
          if (
            child.isSelect
            && child.productId === course.productId
            && child.productSkuId !== course.productSkuId
          ) {
            Object.assign(child, { isSelect: false });
          }
        });
        // 当前组超过可选数量置灰
        num = item.productSkuList.filter((child) => child.isSelect).length;
        Object.assign(item, { disbaled: item.groupInfo.selectProductNum === num });
      });
      this.resetPrice()
    },
    skuInfo(data) {
      const { selectSkuInfo } = data;
      this.mandatoryCourse.forEach((item) => {
        if (item.productId === data.productId) {
          Object.assign(item, {
            productSkuId: selectSkuInfo.skuId,
          });
        }
      });
      this.resetPrice()
    },

    initData() {
      const { packageProductRespList, packageId, packageGroupWebRespList } = this.combinationDeatil;
      (packageProductRespList || []).forEach((item) => {
        Object.assign(item, { packageId });
      });
      this.mandatoryCourse = packageProductRespList || [];
      console.log(this.mandatoryCourse, 'this.mandatoryCourse');
      const courses = [];
      (packageGroupWebRespList || []).forEach((element) => {
        const {
          groupId, groupProductNum, name, selectProductNum,
        } = element;
        const productSkuList = [];
        const groupInfo = {};
        Object.assign(groupInfo, {
          groupId,
          groupProductNum,
          name,
          selectProductNum,
          num: 0,
        });
        element.packageProductWebRespList.forEach((course) => {
          const {
            isBuy, isExpire, isSoldOut, isOffline,
          } = course;
          if (!isBuy && !isExpire && !isSoldOut && !isOffline) {
            course.packageProductSkuWebRespList.forEach((child) => {
              const skuSpecJson = JSON.parse(child.skuSpecJson);
              productSkuList.push({
                packageGroupId: groupId,
                packageId: this.currentCourse.cartPackageItem.packageId,
                name: course.productName,
                productId: course.productId,
                productSkuId: child.skuId,
                skuName: child.isDefault ? [] : skuSpecJson.map((item) => item.value),
                isSelect: false,
                disaled: !(
                  (child.isSetStock === 1 && child.availableStock)
                  || child.isSetStock === 0
                ),
              });
            });
          }
        });
        courses.push({ productSkuList, groupInfo });
      });
      this.optionCourse = courses;
      // 增加默认勾选的课程
      const { cartProductItemList } = this.currentCourse.cartPackageItem;
      this.optionCourse.map((item) => {
        item.productSkuList.map((course) => {
          console.log(course, 'course');
          cartProductItemList.map((val) => {
            if (course.productSkuId === val.productSkuId) {
              Object.assign(course, {
                isSelect: true,
              });
            }
          });
        });
        Object.assign(item, { disbaled: item.groupInfo.selectProductNum });
      });

      this.$toast.clear();
    },

    async resetPrice() {
      let flag = true;
      let groupCourse = [];
      this.optionCourse.forEach((item) => {
        const { productSkuList, groupInfo } = item;
        Object.assign(productSkuList, { groupId: groupInfo.groupId });
        const course = productSkuList.filter((list) => list.isSelect);
        groupCourse = [...groupCourse, ...course];
        if (course.length !== groupInfo.selectProductNum) {
          flag = false;
        }
      });
      console.log('flag1111', flag)
      if (this.priceType === 2 && flag) {
        console.log(this.mandatoryCourse, groupCourse)
        const courseList = [...this.mandatoryCourse, ...groupCourse];
        const query = courseList.map((product) => ({
          productId: product.productId,
          skuId: product.productSkuId,
        }));
        if (!query.every(item => item.skuId)) return
        try{
          this.$toast.loading({
            forbidClick: true,
            duration: 0,
          });
          const {data} = await  reqPrice({
            promotionBasicPrice: {
              endPoint: this.$root.$data.isApp ? 2 : 3,
              platform: 1,
            },

            promotionProductPackageReqList: [
              {
                packageId: Number(this.currentCourse.cartPackageItem.packageId),
                packageProductSkuReqList: query,
              },
            ],
          })
          this.price = data.orderPayPrice
          this.$toast.clear();
        } catch(e) {
          this.$toast.clear();
        }
      } else {
        this.price = null
      }

    },

    // 修改规格
    async deterMineBtn() {
      let flag = true;
      let groupCourse = [];
      this.optionCourse.forEach((item) => {
        const { productSkuList, groupInfo } = item;
        Object.assign(productSkuList, { groupId: groupInfo.groupId });
        const course = productSkuList.filter((list) => list.isSelect);
        groupCourse = [...groupCourse, ...course];
        if (course.length !== groupInfo.selectProductNum) {
          flag = false;
        }
      });
      if (flag) {
        const courseList = [...this.mandatoryCourse, ...groupCourse];
        const query = courseList.map((product) => ({
          productId: product.productId,
          skuId: product.productSkuId,
          groupId: product.packageGroupId,
          packageId: product.packageId,
        }));
        const data = {
          cartId: this.currentCourse.cartId,
          cartPackageItemList: query,
          packageId: this.currentCourse.cartPackageItem.packageId,
          type: 2,
        };
        const res = await reqChangeGood(data);
        if (res.code === 0 && res?.data) {
          // this.$toast('修改成功');
          // this.$parent.getCartList();
          this.$emit('reviseType', data);
          this.$emit('singleClose');
        } else {
          this.$toast(res.msg);
          this.$emit('singleClose');
        }
      } else {
        this.$toast('请选择课程');
      }
    },

  },
};
</script>

<style lang="scss" scoped>
::v-deep .van-popup {
  overflow-y: hidden;
  border-radius: 16px 16px 0 0;
}
.content {
  height: 1050px;
   padding-bottom: 150px;
  overflow: hidden;
  .content-box {
    height: 100%;
    padding-bottom: 150px;
    overflow-y: auto;
  }
}
.mandatory {
  // height: 10000px;
  // border-bottom: 20px solid #f9f9f9;
  .mandatory-box{
    border-bottom: 20px solid #f9f9f9;
  }
}
.optional {
  padding: 40px;
  .group-name {
    // height: 100px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    padding-bottom: 32px;
    p {
      width: 100%;
      padding: 0 0 12px 0;
      color: #333;
      font-weight: 600;
      font-size: 32px;
      line-height: 44px;
    }
    span {
      color: #333;
      font-weight: 400;
      font-size: 28px;
      line-height: 40px;
    }
  }
  .optional-course {
    li {
      position: relative;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: flex-start;
      width: 678px;
      height: 105px;
      margin-bottom: 24px;
      padding: 20px;
      background: #fff;
      border: 2px solid #e8e8e8;
      border-radius: 4px;
      p {
        width: 100%;
        color: #333;
        font-weight: 600;
        font-size: 24px;
      }
      span {
        color: #787878;
        font-size: 24px;
      }
      img {
        display: none;
      }
    }
    li.disbaled {
      background: #f9f9f9;
      // opacity: 0.5;
      pointer-events: none;
      p,
      span {
        color: #c8c8c8;
      }
    }
    li.active {
      background: #fff5ed;
      border: 2px solid #ff6c02;
      border-radius: 4px;
      img {
        position: absolute;
        right: 0;
        bottom: -1px;
        display: block;
        width: 29px;
      }
      p,
      span {
        color: #ff6c02;
      }
    }
  }
}
.foot {
  position: fixed;
  bottom: 0;
  z-index: 200;
  width: 750px;
  padding: 20px 0 40px 0;
  background: #fefffe;
  box-shadow: 0 -4px 8px 0 rgba(0, 0, 0, 0.05);
  > div {
    width: 678px;
    height: 82px;
    margin: 0 auto;
    color: #fff;
    font-weight: 500;
    font-size: 29px;
    line-height: 82px;
    text-align: center;
    background: #ff6c02;
    border-radius: 41px;
  }
  .price {
    display: inline-block;
    margin-left: 8px;
    font-size: 29px
  }
}
.courseTitle{
   box-sizing: border-box;
   width: 100%;
   padding:80px 36px 40px 36px;
   background: #f9f9f9;
    h2{
      width: 678px;
      margin-bottom: 22px;
      overflow: hidden;
      color: #333;
      font-weight: 500;
      font-size: 33px;
      line-height: 45px;
      white-space: nowrap;
      text-overflow: ellipsis;

    }
    h3{
    color: #FF3938;
    font-weight: 500;
    font-size: 36px;
      span{
        padding-right: 8px;
        font-size: 25px;
      }
    }
  }
::v-deep .van-icon-cross::before{
  color: #666;
}
</style>
